import usFlag from "../../../assets/images/flags/us.svg"
import turkey from "../../../assets/images/flags/turkey.svg"
import germany from "../../../assets/images/flags/germany.svg"
import spain from "../../../assets/images/flags/spain.svg"
import france from "../../../assets/images/flags/france.svg"
import arabic from "../../../assets/images/flags/arabic.svg"
import russia from "../../../assets/images/flags/russia.svg"
import italy from "../../../assets/images/flags/italy.svg"

const languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  tr: {
    label: "Türkçe",
    flag: turkey,
  },
  de: {
    label: "Deutsch",
    flag: germany,
  },
  es: {
    label: "Español",
    flag: spain,
  },
  fr: {
    label: "Français",
    flag: france,
  },
  ar: {
    label: "العربية",
    flag: arabic,
  },
  ru: {
    label: "Русский",
    flag: russia,
  },
  it: {
    label: "Italiano",
    flag: italy,
  },
}

export default languages;
